import React, { useState, useEffect } from 'react';
import { Table, message, Spin, Grid } from 'antd';
import axiosInstance from '../../../axiosInstance';

export const shopId = localStorage.getItem('shopId'); // Fetching shopId from local storage

const ExpiredProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const screens = Grid.useBreakpoint(); // Using Grid's useBreakpoint

  // Fetch expired products
  const fetchExpiredProducts = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/products/expired/${shopId}`);
      if (response.data && response.data.products) {
        setProducts(response.data.products); // Accessing the 'products' array in the response
        message.success(response.data.message);
      } else {
        message.error('Unexpected response format. Please contact support.');
      }
    } catch (error) {
      message.error('Failed to fetch expired products. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExpiredProducts();
  }, []);

  // Table columns
  const columns = [
    {
      title: 'Product Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      // Show this column only on medium and large screens
      responsive: ['md', 'lg'],
    },
    {
      title: 'Sub-Category',
      dataIndex: 'sub_category',
      key: 'sub_category',
      // Show this column only on medium and large screens
      responsive: ['md', 'lg'],
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      // Show this column only on small and larger screens
      responsive: ['sm', 'md', 'lg'],
    },
    {
      title: 'Expiry Date',
      dataIndex: 'expire_date',
      key: 'expire_date',
      render: (date) => new Date(date).toLocaleDateString(),
    },
  ];

  // Adjust columns based on screen size
  const responsiveColumns = columns.filter((column) => {
    if (!column.responsive) return true;
    return column.responsive.some((size) => screens[size]);
  });

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Expired Products</h2>
      {loading ? (
        <Spin tip="Loading expired products..." />
      ) : products.length > 0 ? (
        <Table
          dataSource={products}
          columns={responsiveColumns}
          rowKey={(record) => record.name} // Using 'name' as the unique key
          bordered
          pagination={{ pageSize: 10 }}
          scroll={{ x: 'max-content' }} // Horizontal scroll for smaller screens
        />
      ) : (
        <p style={styles.noProductsMessage}>No expired products found.</p>
      )}
    </div>
  );
};

// Inline CSS styles
const styles = {
  container: {
    padding: '16px',
    margin: '0 auto',
    maxWidth: '1200px',
  },
  title: {
    textAlign: 'center',
    fontSize: '1.5rem',
    marginBottom: '20px',
  },
  noProductsMessage: {
    textAlign: 'center',
    fontSize: '1rem',
    color: 'gray',
    marginTop: '20px',
  },
};

export default ExpiredProducts;
